module.exports = __webpack_public_path__ + "static/media/ticket-premier-gold.b556d324.svg";